<template>
  <Head :title="seoTitle">
    <link
      rel="canonical"
      :href="$page.props.canonical_url"
      inertia
    >

    <meta
      name="title"
      :content="seoTitle"
    >
    <meta
      v-if="description"
      name="description"
      :content="description"
    >
    <meta
      v-if="keywords"
      name="keywords"
      :content="keywords"
    >

    <Component
      :is="`script`"
      v-if="jsonLd"
      type="application/ld+json"
    >
      {{ jsonLd }}
    </Component>

    <slot />
  </Head>
</template>

<script>
import {Head, Link} from '@inertiajs/vue2';

export default {
  components: {
    Link,
    Head,
  },

  props: {
    title: {
      required: true,
      type: String,
    },

    description: {
      required: false,
      type: String,
      default: null,
    },

    keywords: {
      required: false,
      type: String,
      default: null,
    },

    jsonLd: {
      required: false,
      type: [Array, Object],
      default: null,
    },

    prependNameToTitle: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  computed: {
    seoTitle() {
      return this.prependNameToTitle
        ? `${this.title} | JouwVeilingen.nl`
        : this.title;
    },
  },
};
</script>
